import React, { Component } from "react";
import { Fade } from "react-reveal";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import { contactPageData } from "../../portfolio.js";
import "./ContactComponent.css";

const ContactData = contactPageData.contactSection;

class Contact extends Component {
  render() {
    const theme = this.props.theme;

    return (
      <div className="contact-main">
        {/* <Header theme={theme} /> */}
        <div className="basic-contact">
          {ContactData && (
            <Fade bottom duration={1000} distance="40px">
              <div className="contact-heading-div">
                <div className="contact-heading-text-div">
                  <h1
                    className="contact-heading-text"
                    style={{ color: theme.text }}
                  >
                    {ContactData["title"]}
                  </h1>
                  <p
                    className="contact-header-detail-text subTitle"
                    style={{ color: theme.secondaryText }}
                  >
                    {ContactData["description"]}
                  </p>
                  <p
                    className="contact-header-detail-text subTitle"
                    style={{
                      color: theme.secondaryText,
                      display: "inline-flex",
                      alignItems: "center",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 640 640"
                      style={{
                        width: 26,
                        height: 26,
                        fill: theme.secondaryText,
                      }}
                    >
                      <path d="M128 252.6C128 148.4 214 64 320 64C426 64 512 148.4 512 252.6C512 371.9 391.8 514.9 341.6 569.4C329.8 582.2 310.1 582.2 298.3 569.4C248.1 514.9 127.9 371.9 127.9 252.6zM320 320C355.3 320 384 291.3 384 256C384 220.7 355.3 192 320 192C284.7 192 256 220.7 256 256C256 291.3 284.7 320 320 320z" />
                    </svg>{" "}
                    {ContactData["location"]}
                  </p>
                  <p
                    className="contact-header-detail-text subTitle"
                    style={{ color: theme.secondaryText }}
                  >
                    Open for opportunities: {ContactData["available"]}
                  </p>
                  <SocialMedia theme={theme} />
                  {/* <div className="resume-btn-div">
                    <Button
                      text="📝 My CV"
                      newTab={true}
                      href={greeting.resumeLink}
                      theme={theme}
                    />
                  </div> */}
                </div>
                <div className="contact-heading-img-div">
                  <img
                    src={require(`../../assets/images/${ContactData["profile_image_path"]}`)}
                    // height={360}
                    // width={360}
                    alt=""
                    style={{ borderColor: theme.imageHighlight }}
                  />
                </div>
              </div>
            </Fade>
          )}
          {/* {blogSection && (
            <Fade bottom duration={1000} distance="40px">
              <div className="blog-heading-div">
                <div className="blog-heading-text-div">
                  <h1
                    className="blog-heading-text"
                    style={{ color: theme.text }}
                  >
                    {blogSection["title"]}
                  </h1>
                  <p
                    className="blog-header-detail-text subTitle"
                    style={{ color: theme.secondaryText }}
                  >
                    {blogSection["subtitle"]}
                  </p>
                  <div className="blogsite-btn-div">
                    <Button
                      text="Visit My Blogsite"
                      newTab={true}
                      href={blogSection.link}
                      theme={theme}
                    />
                  </div>
                </div>
                <div className="blog-heading-img-div">
                  <img
                    src={require(`../../assets/images/${blogSection["avatar_image_path"]}`)}
                    alt=""
                  />
                  <BlogsImg theme={theme} />
                </div>
              </div>
            </Fade>
          )} */}
          {/* {addressSection && (
            <Fade bottom duration={1000} distance="40px">
              <div className="address-heading-div">
                <div className="contact-heading-img-div">
                  <img
                        src={require(`../../assets/images/${addressSection["avatar_image_path"]}`)}
                        alt=""
                      />
                  <AddressImg theme={theme} />
                </div>
                <div className="address-heading-text-div">
                  <h1
                    className="address-heading-text"
                    style={{ color: theme.text }}
                  >
                    {addressSection["title"]}
                  </h1>
                  <p
                    className="contact-header-detail-text subTitle"
                    style={{ color: theme.secondaryText }}
                  >
                    {addressSection["subtitle"]}
                  </p>
                  <h1
                    className="address-heading-text"
                    style={{ color: theme.text }}
                  >
                    {phoneSection["title"]}
                  </h1>
                  <p
                    className="contact-header-detail-text subTitle"
                    style={{ color: theme.secondaryText }}
                  >
                    {phoneSection["subtitle"]}
                  </p>
                  <div className="address-btn-div">
                    <Button
                      text="Visit on Google Maps"
                      newTab={true}
                      href={addressSection.location_map_link}
                      theme={theme}
                    />
                  </div>
                </div>
              </div>
            </Fade>
          )} */}
        </div>
        {/* <Footer theme={this.props.theme} onToggle={this.props.onToggle} />
        <TopButton theme={this.props.theme} /> */}
      </div>
    );
  }
}

export default Contact;
